var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 16.8C15.5461 16.8 16.7997 15.5464 16.7997 14C16.7997 12.4536 15.5461 11.2 13.9997 11.2C12.4533 11.2 11.1997 12.4536 11.1997 14C11.1997 15.5464 12.4533 16.8 13.9997 16.8Z",
    fill: "#00B061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.640625 14.0001C2.42457 8.32009 7.73098 4.20001 13.9997 4.20001C20.2683 4.20001 25.5747 8.32004 27.3587 14C25.5747 19.6799 20.2683 23.8 13.9996 23.8C7.73098 23.8 2.42461 19.68 0.640625 14.0001ZM19.5997 14C19.5997 17.0928 17.0925 19.6 13.9997 19.6C10.9069 19.6 8.39974 17.0928 8.39974 14C8.39974 10.9072 10.9069 8.40001 13.9997 8.40001C17.0925 8.40001 19.5997 10.9072 19.5997 14Z",
    fill: "#00B061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.9027328dfeb6cbac765fb91e7deaf109.svg";
export { ForwardRef as ReactComponent };